export const FETCH_TOPICS_REQUEST = 'FETCH_TOPICS_REQUEST';
export const FETCH_TOPICS_SUCCESS = 'FETCH_TOPICS_SUCCESS';
export const FETCH_TOPICS_FAILED = 'FETCH_TOPICS_FAILED';
export const SELECTED_TOPIC = 'SELECTED_TOPIC';
export const RESET_SELECTED_TOPIC = 'RESET_SELECTED_TOPIC';
export const UNSELECT_TOPIC = 'UNSELECT_TOPIC';
